export default __webpack_public_path__ + "static/media/Type.5a958116.svg";